import type { Components } from '@mui/material/styles';

export default function MuiSpeedDialIcon(): Components['MuiSpeedDialIcon'] {
  return {};
}
